import { useCallback, useState } from "react";
import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import Overview from "@/pages/home/components/Overview";
import Categories from "@/pages/home/components/Categories";
import CreatorShowcase from "@/pages/home/components/CreatorShowcase";
import Ranking from "@/pages/home/components/Ranking";
import Rising from "@/pages/home/components/Rising";
import Guide from "@/pages/home/components/Guide";
import Faq from "@/pages/home/components/Faq";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  const [activeCategory, setActiveCategory] = useState("全部");

  const handlePickCategory = useCallback((category: string) => {
    setActiveCategory(category);
    const target = document.getElementById("creators");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);

  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Overview />
        <Categories onPickCategory={handlePickCategory} />
        <CreatorShowcase
          activeCategory={activeCategory}
          onCategoryChange={setActiveCategory}
        />
        <Ranking />
        <Rising />
        <Guide />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}